/* eslint-disable no-undef */
import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  PageContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    minHeight: '100vh'
  }),

  IdBox2: styled('div')({
    backgroundColor: 'white',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minWidth: '30px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '5px',
    alignItems: 'center',
    padding: '0 8px'
  }),

  IdBox: styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
    flexDirection: 'row'
  }),

  IdText: styled('p')({
    fontSize: '14px',
    margin: 0,
    whiteSpace: 'nowrap'
  }),

  CardTop: styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  }),

  SectionFilters: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  })),

  RectangleBar: styled('div')({
    margin: '0 auto',
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px'
  }),

  ContentContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  })),

  FlexContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  })),

  ShowText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529'
  }),

  SelectContainer: styled('div')({
    select: {
      padding: '5px',
      fontSize: '16px',
      border: '0.5px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      }
    }
  }),

  RecordsText: styled('div')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529'
  }),

  MainContent: styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  })),

  PageContent: styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 200px)',
      padding: theme.spacing(3)
    }
  })),

  PropertyGrid: styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(300px, 1fr))',
    justifyItems: 'stretch', // evita centralizar e estreitar colunas
    gap: '10px',
    marginLeft: '0',
    width: '100%',
    marginTop: '5px',
    paddingBottom: '10px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '5px',
      padding: '0 5px'
    }
  })),

  PropertyListContainer: styled('div')(({ theme }) => ({
    backgroundColor: '#EBEBEB',
    display: 'flex',
    padding: '70px auto',
    margin: '0 auto',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      padding: '10px 10px',
      margin: '0 auto'
    },
    [theme.breakpoints.up('md')]: {
      padding: '10px 100px',
      margin: '0 auto'
    }
  })),

  PropertyCard: styled('div')(({ theme }) => ({
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      height: '160px',
      marginLeft: theme.spacing(-5)
    }
  })),

  CardImage: styled('div')<{ imageUrl: string }>(({ imageUrl, theme }) => ({
    height: '200px',
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up('md')]: {
      width: '160px',
      height: '160px',
      borderRadius: '5px 0 0 5px'
    }
  })),

  CardContent: styled('div')(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2)
    }
  })),

  CardTitle: styled('div')(({ theme }) => ({
    fontSize: '18px',
    fontWeight: 600,
    color: '#000000',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      fontSize: '24px'
    }
  })),

  CardButtonsWrapper: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    flex: '1 1 auto' // ocupa o espaço restante
  }),

  CardButtonsTitle: styled('div')(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 400,
    color: 'black',
    [theme.breakpoints.up('md')]: {
      fontSize: '14px'
    }
  })),

  CardButtons: styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center', // centraliza cada linha
    alignItems: 'center',
    alignContent: 'center', // centraliza o bloco de linhas quando há quebra
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    width: '100%',
    '& > *': {
      flex: '0 1 auto' // não estica
    }
    // removido o justifyContent: 'flex-start' no md+
  })),

  //talvez remover
  ViewButton: styled(Button)(({ theme }) => ({
    // width: '100%',                 // remove full width
    width: 'auto',
    flex: '0 1 auto',
    minWidth: 120, // prevent getting too small
    maxWidth: '100%',
    padding: '0 16px',
    height: '40px',
    backgroundColor: '#2C62C7',
    borderRadius: '5px',
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#1E4A8E'
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 130, // consistent size on md+
      height: '48px'
    }
  })),

  //talvez remover
  EditButton: styled(Button)(({ theme }) => ({
    width: 'auto',
    flex: '0 1 auto',
    minWidth: 120,
    maxWidth: '100%',
    padding: '0 16px',
    height: '40px',
    backgroundColor: '#000000',
    borderRadius: '5px',
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#333333'
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 130,
      height: '48px'
    }
  })),

  FlexRow: styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  }),

  SearchContainer: styled('div')({
    marginRight: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '5px'
  }),

  SearchInput: styled('input')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(1.5),
    fontSize: '14px',
    border: '1px solid #5D5F64',
    borderRadius: '5px',
    backgroundColor: '#F8F8F8',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    },
    [theme.breakpoints.up('sm')]: {
      width: '300px'
    }
  })),

  Pagination: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '15px',
    marginBottom: '25px',
    padding: '0 20px',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      padding: '0 10px 25px 0',
      gap: '10px'
    },
    button: {
      padding: '8px 12px',
      [theme.breakpoints.up('md')]: {
        padding: '8px 16px'
      },
      cursor: 'pointer',
      color: 'black',
      border: '1px solid #ddd',
      backgroundColor: 'white',
      borderRadius: '5px',
      fontSize: '14px',
      '&.active': {
        backgroundColor: 'black',
        color: 'white'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'white',
        color: 'black'
      }
    }
  })),

  // Botão genérico com cores parametrizáveis
  ActionButton: styled(Button, {
    shouldForwardProp: (prop) =>
      !['$bg', '$hover', '$text'].includes(prop as string)
  })<{ $bg: string; $hover: string; $text?: string }>(
    ({ theme, $bg, $hover, $text }) => ({
      width: 'auto',
      flex: '0 1 auto',
      minWidth: 120,
      maxWidth: '100%',
      padding: '0 16px',
      height: '40px',
      backgroundColor: $bg,
      color: $text || '#FFFFFF',
      borderRadius: '5px',
      fontSize: '14px',
      fontWeight: 400,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: $hover
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 130,
        height: '48px'
      }
    })
  )
};
